import { render, staticRenderFns } from "./InputSuggest.vue?vue&type=template&id=0f485ce8&scoped=true&lang=pug&"
import script from "./InputSuggest.vue?vue&type=script&lang=ts&"
export * from "./InputSuggest.vue?vue&type=script&lang=ts&"
import style0 from "./InputSuggest.vue?vue&type=style&index=0&id=0f485ce8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f485ce8",
  null
  
)

export default component.exports